export const payTranslate = {
    title: {
        en: "Payment Method",
        cn: "付款方法",
        jpn: "支払方法",
    },
    select: {
        en: "Select Method",
        cn: "選擇方法",
        jpn: "方法を選択",
    },
};
